export interface PaymentType {
  ApiName: string;
  bg_image: string;
  name: string;
}
export const paymentTypes: Record<string, PaymentType> = {
  // Stripe: {
  //   ApiName: 'Stripe',
  //   bg_image: '/stripe.png',
  //   name: 'Stripe',
  // },
  // CashApp: {
  //   ApiName: 'Stripe',
  //   bg_image: '/cmax2-assets/payments/cashapp.png',
  //   name: 'CashApp',
  // },
 Square: {
    ApiName: 'stripe,card',
    bg_image: 'https://cmax-2.pages.dev/assets/payments/master.png',
    name: 'Card',
  },
  CashApp: {
    ApiName: 'whop,cashapp',
    bg_image: '/cmax2-assets/payments/cashapp.png',
    name: 'CashApp',
  },
  // Square: {
  //   ApiName: 'whop,card',
  //   bg_image: '/cmax2-assets/payments/master.png',
  //   name: 'Card',
  // },
//  Square: {
//     ApiName: 'square,card',
//     bg_image: 'https://cmax-2.pages.dev/assets/payments/master.png',
//     name: 'Card',
//   },
  Chime: {
    ApiName: 'Chime',
    bg_image: '/cmax2-assets/payments/chime.png',
    name: 'Chime',
  },
  Zelle: {
    ApiName: 'Zelle',
    bg_image: '/cmax2-assets/payments/zelle.png',
    name: 'Zelle',
  },
  Paypal: {
    ApiName: 'Paypal',
    bg_image: '/cmax2-assets/payments/paypal.svg',
    name: 'Paypal',
  },
  Venmo: {
    ApiName: 'Venmo',
    bg_image: '/venmo-logo.png',
    name: 'Venmo',
  },
    GooglePay: {
    ApiName: 'GooglePay',
    bg_image: '/cmax2-assets/payments/google-pay.webp',
    name: 'GooglePay',
  },
  ApplePay: {
    ApiName: 'ApplePay',
    bg_image: '/apple-logo.png',
    name: 'ApplePay',
  },
  CashApp2: {
    ApiName: 'TapTap,CashApp',
    bg_image: '/cmax2-assets/payments/cashapp.png',
    name: 'CashApp2',
  },
  TapTapCard: {
    ApiName: 'CashTap',
    bg_image: '/cmax2-assets/payments/taptap-card.png',
    name: 'Card2',
  },
      CashApp1: {
    ApiName: 'stripe,cashapp',
    bg_image: 'https://cmax-2.pages.dev/assets/payments/cashapp.png',
    name: 'CashApp1',
  },
  
};
